var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoWhere(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 150,
    viewBox: "0 0 160 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8125 37.5H4.6875C2.09875 37.5 0 35.4012 0 32.8125V4.6875C0 2.09875 2.09875 0 4.6875 0H32.8125C35.4012 0 37.5 2.09875 37.5 4.6875V32.8125C37.5 35.4012 35.4012 37.5 32.8125 37.5Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8125 93.75H4.6875C2.09875 93.75 0 91.6512 0 89.0625V60.9375C0 58.3487 2.09875 56.25 4.6875 56.25H32.8125C35.4012 56.25 37.5 58.3487 37.5 60.9375V89.0625C37.5 91.6512 35.4012 93.75 32.8125 93.75Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8125 150H4.6875C2.09875 150 0 147.901 0 145.312V117.188C0 114.599 2.09875 112.5 4.6875 112.5H32.8125C35.4012 112.5 37.5 114.599 37.5 117.188V145.312C37.5 147.901 35.4012 150 32.8125 150Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.312 37.5H51.5625C48.9737 37.5 46.875 35.4012 46.875 32.8125V4.6875C46.875 2.09875 48.9737 0 51.5625 0H155.312C157.901 0 160 2.09875 160 4.6875V32.8125C160 35.4012 157.901 37.5 155.312 37.5Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155.312 93.75H51.5625C48.9737 93.75 46.875 91.6512 46.875 89.0625V60.9375C46.875 58.3487 48.9737 56.25 51.5625 56.25H155.312C157.901 56.25 160 58.3487 160 60.9375V89.0625C160 91.6512 157.901 93.75 155.312 93.75Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.312 150H51.5625C48.9737 150 46.875 147.901 46.875 145.312V117.188C46.875 114.599 48.9737 112.5 51.5625 112.5H155.312C157.901 112.5 160 114.599 160 117.188V145.312C160 147.901 157.901 150 155.312 150Z",
    fill: "url(#paint5_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 18.75,
    y1: 37.5,
    x2: 18.75,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A93AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF81FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 18.75,
    y1: 93.75,
    x2: 18.75,
    y2: 56.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A93AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF81FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 18.75,
    y1: 150,
    x2: 18.75,
    y2: 112.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A93AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF81FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 103.438,
    y1: 37.5,
    x2: 103.438,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A93AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF81FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 103.438,
    y1: 93.75,
    x2: 103.438,
    y2: 56.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A93AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF81FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 103.438,
    y1: 150,
    x2: 103.438,
    y2: 112.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A93AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF81FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoWhere);
export default __webpack_public_path__ + "static/media/picto_where.55a875d0bf889e4d47c1ba67a56745d4.svg";
export { ForwardRef as ReactComponent };